import { SideBar } from 'Components/SideBar';
import { Header } from 'Components/Header';
import { Main, SecondColumn } from '../styles';
import { Footer } from 'Components/Footer';
import { useSelector } from 'react-redux';
import { useMenuStatus } from 'store/menu';

export const LayoutAuthenticated = ({children}) => {
    const openMenu = useSelector(useMenuStatus);
    
    return (
        <Main>
            <SideBar/>
            <SecondColumn className={openMenu ? 'menu-open' : 'menu-close'}>
                <Header openMenu={openMenu}/>
                <main style={{marginBottom: '40px', position: 'relative'}}>
                    {children}
                </main>
                <Footer/>
            </SecondColumn>
        </Main>
    )
}